import React from "react";
import "./Footer.css";
import { CALENDLY_URL } from "../../utils/links";
import Logo from "../../images/logo.png";
import {
  Fb,
  Instagram,
  MF,
  Preel,
  QF,
  Tiktok,
  Youtube,
} from "../../images/images";

const quickLinksCol1 = [
  { label: "About us", href: "/about" },
  {
    label: "Contact us",
    href: "/contact",
  },
  {
    label: "Testimonies",
    href: "https://launcher.nucleus.church/launcher/4f6c8b56bda9dab3c8ef/",
  },
  { label: "Events", href: "/events" },
  {
    label: "Past livestreams",
    href: "https://m.youtube.com/@Chantalekabeministries/streams",
  },
  { label: "Partner with us ", href: "/partner" },
];

const quickLinksCol2 = [
  {
    label: "Join a Community",
    href: "https://launcher.nucleus.church/flow/47e0a0536ea78c712113?nucleuslauncher=openflow&nlflow=47e0a0536ea78c712113",
  },
  { label: "Book an Appointment", href: CALENDLY_URL },
];

const socials = [
  {
    label: "Facebook",
    icon: Fb,
    href: "https://www.facebook.com/share/1CRpAszBuk/",
  },
  {
    label: "Tiktok",
    icon: Tiktok,
    href: "https://www.tiktok.com/@chantalekabeministries",
  },
  {
    label: "Instagram",
    icon: Instagram,
    href: "https://instagram.com/chantalekabeministries",
  },
  {
    label: "Youtube",
    icon: Youtube,
    href: "https://youtube.com/@chantalekabeministries",
  },
];

const extraSocials = [
  {
    label: "Pinterest",
    icon: Preel,
    href: "https://www.pinterest.com/CHANTALEKABEMINISTRIES/",
  },
  {
    label: "Medium",
    icon: MF,
    href: "https://medium.com/@info_93047",
  },

  {
    label: "Quora",
    icon: QF,
    href: "https://www.quora.com/profile/CHANTAL-EKABE-MINISTRIES/",
  },
];

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="footer-section footer-section-1">
      <div className="footer-logo">
        <img src={Logo} alt="logo" className="footer-logo-img" />
      </div>
      <div className="footer-desc">
        At Chantal Ekabe Ministries, we believe in the power of Jesus Christ to
        heal, restore, and transform lives.
      </div>
      <div className="footer-address-label">Address:</div>
      <div className="footer-address">
        6140 S Gun Club Rd K6, Aurora, CO 80016 Unit F-110
      </div>
    </div>
    <div className="footer-section footer-section-2">
      <div className="footer-links-header">Quick Links</div>
      <div className="footer-links-columns">
        <div className="footer-links-col">
          {quickLinksCol1.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="footer-link"
              target={link.href.startsWith("http") ? "_blank" : undefined}
              rel={
                link.href.startsWith("http") ? "noopener noreferrer" : undefined
              }
            >
              {link.label}
            </a>
          ))}
        </div>
        <div className="footer-links-col">
          {quickLinksCol2.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="footer-link"
              target={link.href.startsWith("http") ? "_blank" : undefined}
              rel={
                link.href.startsWith("http") ? "noopener noreferrer" : undefined
              }
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </div>
    <div className="footer-section footer-section-3">
      <div className="footer-social-header">Follow Us</div>
      <div className="footer-socials-row">
        <div className="footer-socials">
          {socials.map((s) => (
            <a
              key={s.label}
              href={s.href}
              className="footer-social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="footer-social-icon">
                <img src={s.icon} alt={s.label} />
              </span>
              <span className="footer-social-text">{s.label}</span>
            </a>
          ))}
        </div>
        <div className="footer-extra-socials">
          {extraSocials.map((s) => (
            <a
              key={s.label}
              href={s.href}
              className="footer-social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="footer-social-icon">
                <img src={s.icon} alt={s.label} />
              </span>
              <span className="footer-social-text">{s.label}</span>
            </a>
          ))}
        </div>
      </div>
      <div className="footer-live-desc">
        Join us live on youtube 8:00 am MST
      </div>
      <div className="footer-live-days">Monday To Friday</div>
    </div>
  </footer>
);

export default Footer;
